export const adminDashboardRoute = {
  dashboardHome: "/backoffice/dashboard",
  users: "/backoffice/users",
  tickets: "/backoffice/tickets",
  settings: "/backoffice/settings",
  faq: "/backoffice/faq",
  profile: "/backoffice/profile",
};

export const userDashboardRoute = {
  dashboardHome: "/frontoffice/dashboard",
  projects: "/frontoffice/projects",
  projectDetails: "/frontoffice/projects/:projectId",
  newProject: "/frontoffice/new",
  newTicket: "/frontoffice/new-ticket",
  tickets: "/frontoffice/tickets",
  buyCredits: "/frontoffice/buy-credits",
  buyCreditsCheckout: "/frontoffice/buy-credits/checkout",
  faq: "/frontoffice/faq",
  profile: "/frontoffice/profile",
  successPage: "/frontoffice/success",
  errorPage: "/frontoffice/error",
};
export const commonRoutes = {
  login: "/login",
  firstLogin: "/change-password",
  register: "/register",
  contacts: "/contacts",
  notFound: "/not-found",
};

export const roleRoutes = {
  admin: [
    ...Object.values(adminDashboardRoute),
    ...Object.values(commonRoutes),
  ],
  user: [...Object.values(userDashboardRoute), ...Object.values(commonRoutes)],
};
